import { render, staticRenderFns } from "./initallform.vue?vue&type=template&id=4fcd91da&scoped=true"
import script from "./initallform.vue?vue&type=script&lang=js"
export * from "./initallform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd91da",
  null
  
)

export default component.exports